import { render, staticRenderFns } from "./monthlyTrafficStatisticsDeatil.vue?vue&type=template&id=5ab209d2&"
import script from "./monthlyTrafficStatisticsDeatil.vue?vue&type=script&lang=js&"
export * from "./monthlyTrafficStatisticsDeatil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports